/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreditRequestLogDto } from '../../models/credit-request-log-dto';

export interface CreditRequestLogControllerDelete$Params {
  id: string;
}

export function creditRequestLogControllerDelete(http: HttpClient, rootUrl: string, params: CreditRequestLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
  const rb = new RequestBuilder(rootUrl, creditRequestLogControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditRequestLogDto>;
    })
  );
}

creditRequestLogControllerDelete.PATH = '/api/creditRequestLog/{id}';
